export const isSupportBrowser = (userAgent?: string) => {
    // 检查是否在服务端环境
    const isServer = typeof window === 'undefined';
    
    // 在服务端环境中，只使用传入的 userAgent
    // 在客户端环境中，如果没有传入 userAgent，则使用 navigator.userAgent
    var ua = userAgent || (!isServer && navigator ? navigator.userAgent : '');
    
    // 如果没有有效的 userAgent，则默认返回兼容
    if (!ua) {
        return true;
    }
    
    var browserName = '';
    var browserVersion = 0;
    var isCompatible = false;
    
    // 检测Chrome
    if (/Chrome\/([0-9]+)/.test(ua) && !/Edg\//.test(ua) && !/OPR\//.test(ua)) {
        browserName = 'Chrome';
        browserVersion = parseInt(RegExp.$1, 10);
        isCompatible = browserVersion >= 85; // Chrome 85+支持逻辑赋值运算符
    }
    // 检测Firefox
    else if (/Firefox\/([0-9]+)/.test(ua)) {
        browserName = 'Firefox';
        browserVersion = parseInt(RegExp.$1, 10);
        isCompatible = browserVersion >= 79; // Firefox 79+支持逻辑赋值运算符
    }
    // 检测Safari (非iOS)
    else if (/Safari\/([0-9]+)/.test(ua) && !/Chrome/.test(ua) && !/(iPhone|iPad|iPod)/.test(ua)) {
        browserName = 'Safari';
        if (ua.includes('QQBrowser')) {
            isCompatible = true;
        }else {
            // Safari的版本号在Version/后面
            if (/Version\/([0-9]+)/.test(ua)) {
                browserVersion = parseInt(RegExp.$1, 10);
                isCompatible = browserVersion >= 14; // Safari 14+支持逻辑赋值运算符
            } else {
                isCompatible = false;
            }
        }
    }
    // 检测Edge (Chromium版)
    else if (/Edg\/([0-9]+)/.test(ua)) {
        browserName = 'Edge';
        browserVersion = parseInt(RegExp.$1, 10);
        isCompatible = browserVersion >= 85; // Edge 85+支持逻辑赋值运算符
    }
    // 检测Opera
    else if (/OPR\/([0-9]+)/.test(ua)) {
        browserName = 'Opera';
        browserVersion = parseInt(RegExp.$1, 10);
        isCompatible = browserVersion >= 71; // Opera 71+支持逻辑赋值运算符
    }
    // 检测iOS Safari
    else if (/(iPhone|iPad|iPod)/.test(ua) && /Safari/.test(ua)) {
        browserName = 'iOS Safari';
        // iOS版本在OS后面
        if (/OS ([0-9_]+)/.test(ua)) {
            var iosVersion = RegExp.$1.replace(/_/g, '.');
            browserVersion = parseFloat(iosVersion);
            isCompatible = browserVersion >= 14.0; // iOS 14+支持逻辑赋值运算符
        } else {
            isCompatible = false;
        }
    }
    // 检测Samsung Internet
    else if (/SamsungBrowser\/([0-9.]+)/.test(ua)) {
        browserName = 'Samsung Internet';
        browserVersion = parseFloat(RegExp.$1);
        isCompatible = browserVersion >= 13.0; // Samsung Internet 13.0+支持逻辑赋值运算符
    }
    // 其他浏览器
    else {
        browserName = '未知浏览器';
        isCompatible = true; // 默认兼容
    }
    
    // 记录浏览器信息
    console.log('浏览器: ' + browserName + ' ' + browserVersion);
    console.log('兼容性: ' + (isCompatible ? '支持' : '不支持') + '逻辑赋值运算符');
    
    return isCompatible
}
